import { useLayoutEffect, useState } from 'react'

const DEFAULT_THEME = 'light'

/**
 * 다크/라이트 테마를 구독한다.
 *
 * containerRef 는 선택이다. 주면 그 요소에서 가장 가까운 테마 루트를 찾고, 없으면 문서에서
 * 찾는다. 코인 로고처럼 여러 컴포넌트에 흩어져 있는 곳은 ref 를 달기 어려워 문서 조회를 쓴다.
 */
export const useMStockThemeMode = (containerRef) => {
  const [theme, setTheme] = useState(DEFAULT_THEME)

  useLayoutEffect(() => {
    const themeRoot =
      containerRef?.current?.closest('.theme-mstock') ??
      document.querySelector('.theme-mstock')

    if (!themeRoot) {
      return
    }

    const updateTheme = () => {
      setTheme(themeRoot.dataset.theme === 'dark' ? 'dark' : 'light')
    }

    updateTheme()

    const observer = new MutationObserver(updateTheme)

    observer.observe(themeRoot, {
      attributes: true,
      attributeFilter: ['data-theme']
    })

    return () => {
      observer.disconnect()
    }
  }, [containerRef])

  return theme
}
